import React from "react";
import img from '../../imgs/chatImage.png'
import { MessageType, Participant } from "../../types/chat";
import { formatDistanceToNow } from "date-fns";
import { ar } from "date-fns/locale";
import { IoPerson } from "react-icons/io5";
interface chatProps {
    unreadCound: number;
    user: Participant[];
    lastMessage: MessageType;
}
const ChatCard = (chatProps: chatProps) => {


    return (
        <div className="relative">
            <div className="flex items-center justify-between gap-4 p-4 bg-white border-b border-gray-500 shadow-md hover:bg-gray-100 transition cursor-pointer">

                <div className="flex flex-col items-center">

                    <span className="text-xs text-gray-500">
                        {formatDistanceToNow(new Date(chatProps.lastMessage.updatedAt), { addSuffix: true, locale: ar })}
                    </span>
                    {chatProps.unreadCound > 0 ?
                        <span className="bg-primary-200 text-white text-xs font-bold px-2 py-1 rounded-full mt-1">
                            {chatProps.unreadCound}
                        </span>
                        :
                        ""
                    }
                </div>


                <div className="flex-1 text-right">
                    <h3 className="text-lg font-semibold text-gray-800">{chatProps.user[0].name}</h3>
                    <p className="text-sm text-gray-600 truncate max-w-[200px]">
                        {chatProps.lastMessage.content}
                    </p>
                </div>

                <div className="w-14 h-14 rounded-full overflow-hidden">
                    {chatProps.user[0].profileImage ?
                        <img src={chatProps.user[0].profileImage ? chatProps.user[0].profileImage : img} alt="" className="w-full h-full" /> :
                        <div
                            className='w-10 h-10 rounded-full flex items-center justify-center overflow-hidden cursor-pointer bg-gradient-to-b from-neutral-400 to-neutral-300' // Moved gradient to container
                        >
                            <IoPerson size={25} color='#8e8e8' />
                        </div>} 

                </div>
            </div>
        </div >



    );
};

export default ChatCard;
